import { useApiPaginated } from "@/hooks/useApiPaginated";
import { queryKeys } from "@/lib/queryKeys";

export interface ProjectMembership {
  id: string;
  project_id: string;
  member_id: string;
  project_role: string;
  default_autonomy: string;
  created_at: string;
}

export function useProjectMembershipsPaginated(
  projectId: string | null,
  page: number,
  pageSize: number,
  q = "",
) {
  const url = projectId ? `/api/v2/projects/${projectId}/memberships` : null;
  const { data, total, loading, error, refetch } = useApiPaginated<ProjectMembership>(
    queryKeys.projects.memberships(projectId ?? "", { page, pageSize, q }),
    url,
    page,
    pageSize,
    { q },
    "Failed to load memberships",
  );
  return { memberships: data, total, loading, error, refetch };
}
